import React, { useEffect } from 'react';
import ApiValidationErrorDisplay from '~/components/ApiValidationErrorDisplay';
import { clearApiValidationErrors } from '~/stores/redux/common/apiValidationErrorSlice';
import { schema } from './webMatchPrediction.yup';
import DisplayFormikState from '~/components/DisplayFormikState';
import SubmitResetButtons from '~/components/FormControl/SubmitResetButtons';
import classNames from 'classnames/bind';
const cx = classNames.bind();
import { FormText, FormSelect, TextArea, Selectize, FormNumber } from '~/components/FormControl';
import { Formik } from 'formik';
import { Card, Form } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';
import { Col } from 'react-bootstrap';
import { FileUploadedWithResetCount } from '~/components/FileUploaded';
import { useNavigate } from 'react-router-dom';
import { fetchCardMetaDataApi } from '~/pages/CardSaga/cardMetaDataSlice';
import { SPECIAL_OFFER_TYPE } from '~/config/constants';

WebMatchPredictionForm.defaultProps = {
    pictureAttributeNames: null,
};
WebMatchPredictionForm.propTypes = {
    initialValues: PropTypes.object.isRequired,
    setResetCount: PropTypes.func.isRequired,
    pictureAttributeNames: PropTypes.array,
    resetCount: PropTypes.number.isRequired,
    formSubmit: PropTypes.func.isRequired,
};

function WebMatchPredictionForm({ initialValues, setResetCount, pictureAttributeNames, resetCount, formSubmit }) {
    const { isLoading } = useSelector((state) => state.loading);
    const { apiValidationErrors } = useSelector((state) => state.apiValidationError);

    const { cardMetaData } = useSelector((state) => state.cardSaga.cardMetaData);

    const dispatch = useDispatch();
    const navigate = useNavigate();
    pictureAttributeNames = ['banner_image'];

    useEffect(() => {
        if (isEmpty(cardMetaData)) {
            dispatch(fetchCardMetaDataApi(navigate));
        }
    }, []);

    return (
        <>
            {/* MUST put `isEmpty(webMatchPredictionMetaData)` in condition, else Bootstrap `Select` will not display value to UI (even though it's already stored value in it)  */}
            {!isEmpty(initialValues) && !isEmpty(cardMetaData) ? (
                <Card>
                    <Card.Body>
                        <Formik
                            initialValues={initialValues}
                            validateOnChange={false}
                            validationSchema={initialValues.id === null ? schema : schema(true)}
                            onSubmit={formSubmit}
                        >
                            {(props) => {
                                // eslint-disable-next-line react/prop-types
                                const { handleSubmit, isSubmitting, resetForm, values, setFieldValue } = props;

                                return (
                                    <>
                                        <SubmitResetButtons
                                            isSubmitting={isSubmitting}
                                            handleSubmit={handleSubmit}
                                            setResetCount={setResetCount}
                                            resetForm={resetForm}
                                        />

                                        <Form.Row className="d-flex justify-content-between">
                                            <Selectize
                                                name={'p1_class'}
                                                options={cardMetaData.characterClasses}
                                                label="Player 1 class"
                                                sm={6}
                                            />
                                            <Selectize
                                                name={'p2_class'}
                                                options={cardMetaData.characterClasses}
                                                label="Player 2 class"
                                                sm={6}
                                            />
                                        </Form.Row>

                                        <Form.Row className="d-flex justify-content-between">
                                            <Selectize
                                                name={'p1_powers'}
                                                options={cardMetaData.powers}
                                                label="Player 1 powers"
                                                sm={6}
                                            />
                                            <Selectize
                                                name={'p2_powers'}
                                                options={cardMetaData.powers}
                                                label="Player 2 powers"
                                                sm={6}
                                            />
                                        </Form.Row>

                                        <Form.Row className="d-flex justify-content-between">
                                            <FormText
                                                sm="4"
                                                name="close_at"
                                                className="d-flex flex-column justify-content-end"
                                                label={'Close at (UTC time) YYYY-MM-DD HH:mm:ss'}
                                                
                                            />
                                            <FormText
                                                sm="4"
                                                name="release_at"
                                                className="d-flex flex-column justify-content-end"
                                                label={'Release at (UTC time) YYYY-MM-DD HH:mm:ss'}
                                                
                                            />
                                            <FormSelect
                                                name="result"
                                                options={[{ id: '1', name: 'Player 1 Win' }, { id: '2', name: 'Tie' }, { id: '3', name: 'Player 2 Win' }]}
                                                sm={4}
                                                label="Result"
                                            />
                                        </Form.Row>

                                        <Form.Row className="d-flex justify-content-between">
                                            <FormText
                                                sm="12"
                                                name="video_url"
                                                className="d-flex flex-column justify-content-end"
                                            />
                                        </Form.Row>

                                        <Form.Row className="d-flex justify-content-between">

                                        </Form.Row>

                                        <SubmitResetButtons
                                            isSubmitting={isSubmitting}
                                            handleSubmit={handleSubmit}
                                            setResetCount={setResetCount}
                                            resetForm={resetForm}
                                        />
                                        <ApiValidationErrorDisplay
                                            errors={apiValidationErrors}
                                            clearError={clearApiValidationErrors}
                                        />
                                        <DisplayFormikState props={props} />
                                    </>
                                );
                            }}
                        </Formik>
                    </Card.Body>
                </Card>
            ) : (
                <Card style={{ position: 'relative' }}>
                    <Card.Body className={cx('row', { whirl: isLoading })}></Card.Body>
                </Card>
            )}
        </>
    );
}

export default WebMatchPredictionForm;
